import React, { createContext, useContext, useState } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const accessToken = Cookies.get("accessToken");
    const accessTokenExpiry = Cookies.get("accessTokenExpiry");
    if (accessToken && accessTokenExpiry) {
      const expirationDate = new Date(accessTokenExpiry);
      if (expirationDate > new Date()) {
        return true;
      } else {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        Cookies.remove("accessTokenExpiry");
        return false;
      }
    }
    return false;
  });

  const login = async (accessToken, refreshToken, expiresIn) => {
    try {
      const expirationTimestamp = new Date(Date.now() + expiresIn * 1000);

      // In development, secure flag should be false (HTTP), in production true (HTTPS)
      const isProduction = process.env.NODE_ENV === "production";
      const cookieOptions = {
        expires: expirationTimestamp,
        secure: isProduction,
        sameSite: "Strict",
      };

      // Set cookies with error handling
      Cookies.set("accessToken", accessToken, cookieOptions);
      Cookies.set("refreshToken", refreshToken, cookieOptions);
      Cookies.set("accessTokenExpiry", expirationTimestamp.toISOString(), cookieOptions);

      // Verify cookies were set
      const storedToken = Cookies.get("accessToken");
      if (!storedToken) {
        throw new Error("Failed to store authentication token");
      }

      setIsAuthenticated(true);
      return Promise.resolve();
    } catch (error) {
      console.error("Error during login:", error);
      // Clean up any partially set cookies
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
      Cookies.remove("accessTokenExpiry");
      return Promise.reject(error);
    }
  };

  const logout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("accessTokenExpiry");

    setIsAuthenticated(false);
  };

  return <AuthContext.Provider value={{ isAuthenticated, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
